'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * On page load and on window resize, render a background image with a size optimal for the current viewport
 */

var $blocks = void 0;
var isMobile = false;
var isTablet = false;
var windowSize = void 0;

var cacheDOM = function cacheDOM() {
  $blocks = $('[data-responsive-bg]');
};

var setBackgroundImage = function setBackgroundImage($block, src) {
  $block.css('background-image', 'url(' + src + ')');
};

var checkImage = function checkImage($block) {
  if (isMobile) {
    setBackgroundImage($block, $block.data('mobileImgSrc'));
  } else if (isTablet) {
    setBackgroundImage($block, $block.data('tabletImgSrc'));
  } else {
    setBackgroundImage($block, $block.data('desktopImgSrc'));
  }
};

var getWindowSize = function getWindowSize() {
  windowSize = $(document).width();
  if (windowSize <= 767) {
    isMobile = true;
    isTablet = false;
  } else if (windowSize <= 1023) {
    isMobile = false;
    isTablet = true;
  } else {
    isMobile = false;
    isTablet = false;
  }
};

var bindUIActions = function bindUIActions() {
  $(document).on('ready', function () {
    getWindowSize();
    $blocks.each(function (index, element) {
      checkImage($(element));
    });
  });
  $(window).resize(function () {
    getWindowSize();
    $blocks.each(function (index, element) {
      checkImage($(element));
    });
  });
};

var init = exports.init = function init() {
  cacheDOM();
  bindUIActions();
};

exports.default = {
  init: init
};

// (function (ResponsiveBackgrounds, $) {

//   'use strict';

//   let $blocks;
//   let isMobile = false;
//   let isTablet = false;
//   let windowSize;

//   const cacheDOM = function () {
//     $blocks = $('[data-responsive-bg]');
//   };

//   const checkImage = function ($block) {
//     if (isMobile) {
//       setBackgroundImage($block, $block.data('mobileImgSrc'));
//     } else if (isTablet) {
//       setBackgroundImage($block, $block.data('tabletImgSrc'));
//     } else {
//       setBackgroundImage($block, $block.data('desktopImgSrc'));
//     }
//   };

//   const getWindowSize = function () {
//     windowSize = $(document).width();
//     if (windowSize <= 767) {
//       isMobile = true;
//       isTablet = false;
//     } else if (windowSize <= 1023) {
//       isMobile = false;
//       isTablet = true;
//     } else {
//       isMobile = false;
//       isTablet = false;
//     }
//   };

//   var setBackgroundImage = function ($block , src) {
//     $block.css('background-image', 'url(' +src+ ')');
//   };

//   const bindUIActions = function () {
//     $(document).on('ready', function () {
//       getWindowSize();
//       $blocks.each(function () {
//         checkImage($(this));
//       });
//     });
//     $(window).resize(function () {
//       getWindowSize();
//       $blocks.each(function () {
//         checkImage($(this));
//       });
//     });
//   };

//   ResponsiveBackgrounds.init = function () {
//     cacheDOM();
//     bindUIActions();
//   };

// }(window.ResponsiveBackgrounds = window.ResponsiveBackgrounds || {}, jQuery));